import _classCallCheck from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _defineProperty from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { Result, ValueObject } from '@digibricks/core';
export var SubmissionOverviewStatus = /*#__PURE__*/function (_ValueObject) {
  _inherits(SubmissionOverviewStatus, _ValueObject);

  var _super = _createSuper(SubmissionOverviewStatus);

  function SubmissionOverviewStatus() {
    _classCallCheck(this, SubmissionOverviewStatus);

    return _super.apply(this, arguments);
  }

  _createClass(SubmissionOverviewStatus, [{
    key: "value",
    get: function get() {
      return this.props;
    }
  }], [{
    key: "create",
    value: function create(value) {
      return Result.ok(new SubmissionOverviewStatus(value));
    }
  }]);

  return SubmissionOverviewStatus;
}(ValueObject);

_defineProperty(SubmissionOverviewStatus, "resources", ['1', // un-finished
'2', // finished
'3' // banned
]);

_defineProperty(SubmissionOverviewStatus, "unFinished", SubmissionOverviewStatus.create(SubmissionOverviewStatus.resources[0]).getValue());

_defineProperty(SubmissionOverviewStatus, "finished", SubmissionOverviewStatus.create(SubmissionOverviewStatus.resources[1]).getValue());

_defineProperty(SubmissionOverviewStatus, "banned", SubmissionOverviewStatus.create(SubmissionOverviewStatus.resources[2]).getValue());